import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { startLoading, stopLoading, setLoadingMessage } from '../redux/globalLoadingSlice';

export const useGlobalLoading = () => {
  const dispatch = useDispatch();

  const startGlobalLoading = useCallback((message?: string, loadingId?: string) => {
    dispatch(startLoading({ message, loadingId }));
  }, [dispatch]);

  const stopGlobalLoading = useCallback((loadingId?: string) => {
    dispatch(stopLoading({ loadingId }));
  }, [dispatch]);

  const updateLoadingMessage = useCallback((message: string) => {
    dispatch(setLoadingMessage(message));
  }, [dispatch]);

  return {
    startGlobalLoading,
    stopGlobalLoading,
    updateLoadingMessage,
  };
};
